import { EDIT_FORMDEFINITION_TABS } from "developer/formsCRUD/constants";
import {
  editFormDefinition,
  FormDefinition,
} from "developer/formsCRUD/store/formDefinitionsSlice";
import { Workspace } from "developer/workspaces/model";
import { Form } from "react-final-form";
import { useAppDispatch } from "store/hooks";
import TabPanel from "../TabPanel";
import FormDefinitionTab, { FormState } from "./FormDefinitionTab";

type FormDefinitionTabPanelProps = {
  tabSelected: number;
  formDefinition: FormDefinition;
  workspaces: Workspace[];
  onClose: () => void;
  onMount: (formState: FormState) => void;
};

const FormDefinitionTabPanel = (props: FormDefinitionTabPanelProps) => {
  const { tabSelected, workspaces, formDefinition, onClose, onMount } = props;
  const dispatch = useAppDispatch();

  const handleSubmit = (values: FormDefinition) => {
    dispatch(editFormDefinition(values));
    onClose();
  };

  return (
    <TabPanel value={tabSelected} index={EDIT_FORMDEFINITION_TABS.Form}>
      <Form
        onSubmit={handleSubmit}
        initialValues={formDefinition}
        render={({ handleSubmit }) => (
          <FormDefinitionTab
            formDefinition={formDefinition}
            handleSubmit={handleSubmit}
            workspaces={workspaces}
            onMount={onMount}
          />
        )}
      />
    </TabPanel>
  );
};

export default FormDefinitionTabPanel;
